import React from "react";
import { Redirect } from 'react-router-dom';

const Dashboard: React.FC<any> = () => (
  <Redirect to="/bookings" />
);
export default Dashboard;
